import { create } from "zustand";

interface FollowUpHospitalState {
  followUpHospital: string | null;
  setFollowUpHospital: (hospital: string | null) => void;
}

export const useFollowUpHospitalStore = create<FollowUpHospitalState>(
  (set) => ({
    followUpHospital: null,
    setFollowUpHospital: (hospital) => set({ followUpHospital: hospital }),
  })
);
